import axiosConfig from "../../utils/axiosConfig";

export const callVisitorsCustomers = async () => {
  const {data, status} = await axiosConfig.get(`/visitorsCustomers`);
  return {data, status};
};